import AppCardMainLayout from './AppCardMainLayout.vue';

export default AppCardMainLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/cardlayouts/CardMainLayout/index.ts